module.exports = __webpack_public_path__ + "static/media/V8.85c80575.mp4";